import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getLoggedInWorkspaceRequest = {};
var _getLoggedInWorkspaceResponse = { workspace: '_workspace' };
var _getMyWorkspacesRequest = {};
var _getMyWorkspacesResponse = { workspaces: '_workspace' };
var _workspace = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
};
function resolveWixOsWorkspacesV1WorkspaceServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
            {
                srcPath: '/v1/workspaces',
                destPath: '/v1/workspaces',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_serverless/workspace-service',
                destPath: '',
            },
            {
                srcPath: '/v1/workspaces',
                destPath: '/v1/workspaces',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/workspace-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** get current user workspaces */
export function getMyWorkspaces(payload) {
    var _a = serializer(_getMyWorkspacesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyWorkspacesResponse, {
        _workspace: _workspace,
    }).fromJSON;
    function __getMyWorkspaces(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.os.v1.workspace',
            method: 'GET',
            methodFqn: 'wix.os.workspaces.v1.WorkspaceService.GetMyWorkspaces',
            url: resolveWixOsWorkspacesV1WorkspaceServiceUrl({
                protoPath: '/v1/workspaces',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyWorkspaces.fromReq = fromReq;
    __getMyWorkspaces.__isAmbassador = true;
    return __getMyWorkspaces;
}
/** get current user workspace */
export function getLoggedInWorkspace(payload) {
    var _a = serializer(_getLoggedInWorkspaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoggedInWorkspaceResponse, {
        _workspace: _workspace,
    }).fromJSON;
    function __getLoggedInWorkspace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.os.v1.workspace',
            method: 'GET',
            methodFqn: 'wix.os.workspaces.v1.WorkspaceService.GetLoggedInWorkspace',
            url: resolveWixOsWorkspacesV1WorkspaceServiceUrl({
                protoPath: '/v1/workspaces/logged_in_workspace',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoggedInWorkspace.fromReq = fromReq;
    __getLoggedInWorkspace.__isAmbassador = true;
    return __getLoggedInWorkspace;
}
//# sourceMappingURL=http.impl.js.map